export const RING_PRO_SEO_IMAGE_PATH = '/web_v2/meta-assets/ring-pro-og-lg.png';

const RING_AIR_SEO_IMAGE_PATHS = [
  '/web_v2/meta-assets/ring-air-og-lg-1.png',
  '/web_v2/backgrounds/ring-air-hero.png',
];

const isUS = (region?: string) => (region || '').toUpperCase() === 'US';

export const toUSSeoImage = (
  imageUrl: string | undefined,
  region?: string,
): string | undefined => {
  if (!imageUrl || !isUS(region)) return imageUrl;
  return RING_AIR_SEO_IMAGE_PATHS.reduce(
    (url, airPath) => url.replace(airPath, RING_PRO_SEO_IMAGE_PATH),
    imageUrl,
  );
};

export const RING_AIR_SEO_DESCRIPTION =
  'Ultrahuman Ring AIR ® is the world’s most comfortable and compact smart ring that monitors your sleep, movement and recovery.';

export const RING_PRO_SEO_DESCRIPTION =
  'Ultrahuman Ring PRO is a next-generation smart health ring with advanced biosensors that deliver precise sleep tracking, recovery scores, and metabolic insights.';

const US_SEO_TEXT_SWAPS: [string, string][] = [
  [RING_AIR_SEO_DESCRIPTION, RING_PRO_SEO_DESCRIPTION],
  ['Ultrahuman Ring AIR', 'Ultrahuman Ring PRO'],
];

/** For US, swap Ring AIR SEO text for the Ring Pro equivalent (exact matches only). */
export const toUSSeoText = (text: string, region?: string): string =>
  isUS(region)
    ? US_SEO_TEXT_SWAPS.reduce((t, [air, pro]) => t.replace(air, pro), text)
    : text;

export const usSeoImagePath = (
  region: string | undefined,
  ringAirPath: string,
): string => (isUS(region) ? RING_PRO_SEO_IMAGE_PATH : ringAirPath);
